import { useState, useEffect, useRef } from "react";
import { onValue, ref as realtimeRef, update } from "firebase/database";
import { dbRealtime } from "../../../../firebaseConfig";

/**
 * Custom hook to manage chat data and unread message counts
 * @param {string} packageId - Current package ID
 * @returns {Object} Chat data and unread counts
 */
export const useChatData = (packageId) => {
  const [chatsData, setChatsData] = useState([]);
  const [chatsOrderData, setChatsOrderData] = useState([]);
  const [unreadCounts, setUnreadCounts] = useState({});

  // Listen to specific package chats
  useEffect(() => {
    if (packageId) {
      const chatRef = realtimeRef(
        dbRealtime,
        `orderChats/${packageId}/chats`
      );

      const unsubscribe = onValue(chatRef, (snapshot) => {
        const data = snapshot.val();
        if (data) {
          const arr = Object.keys(data).map((key) => ({
            id: key,
            ...data[key],
          }));
          setChatsData(arr);
        } else {
          setChatsData([]);
        }
      });

      return () => {
        unsubscribe();
      };
    }
  }, [packageId]);

  // Listen to all order chats for unread counts
  useEffect(() => {
    const chatOrderRef = realtimeRef(dbRealtime, "orderChats/");

    const unsubscribe = onValue(chatOrderRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const arr = Object.keys(data).map((key) => ({
          id: key,
          ...data[key],
        }));
        setChatsOrderData(arr);
        console.log(arr, "arr");
      } else {
        setChatsOrderData([]);
      }
    });

    return () => {
      unsubscribe();
    };
  }, []);

  // Calculate unread counts
  useEffect(() => {
    const orderUnreadCounts = {};
    chatsOrderData.forEach((order) => {
      const orderId = order.id;
      orderUnreadCounts[orderId] = order?.unreadAdminMessages || 0;
    });
    setUnreadCounts(orderUnreadCounts);
  }, [chatsOrderData]);

  // Mark messages as read
  const readStatusChange = async (itemId) => {
    if (itemId) {
      const chatRef = realtimeRef(dbRealtime, `orderChats/${itemId}`);
      try {
        await update(chatRef, { unreadAdminMessages: 0 });
      } catch (error) {
        console.error("Error updating read status:", error);
      }
    }
  };

  return {
    chatsData,
    chatsOrderData,
    unreadCounts,
    readStatusChange,
  };
};

